import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import * as SerializationApi from '@/app/state-serialization/api';
import HorizontalTabsComponent from "./horizontal-tabs-component.vue";
import VerticalTabsComponent from "./vertical-tabs-component.vue";
import { VerticalTabsStateProtobufSerializer,
         HorizontalTabsStateProtobufSerializer } from "./tabs-state-protobuf-serializer";
import { IncludeTabsHandler } from './include-tabs-handler';

export const tabsFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(HorizontalTabsComponent)
    .whenTargetNamed("horizontal-tabs");

  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(VerticalTabsComponent)
    .whenTargetNamed("vertical-tabs");

  bind(SerializationApi.StateSerializationPluginSymbol).to(HorizontalTabsStateProtobufSerializer)
  bind(SerializationApi.StateSerializationPluginSymbol).to(VerticalTabsStateProtobufSerializer)

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeTabsHandler);
});
